import React, { useEffect } from "react";
import { Form, Formik } from "formik";
import CustomSelectField from "../components/CustomSelectField";
import CustomInputField from "../components/CustomInputField";
import { oxygenRetailSchema1 } from "../utils/formValidationSchema";
import { useDispatch, useSelector } from "react-redux";
import { getAllBanks, getEmploymentStatus, setCustomermsisdn } from "../redux/features/oxygen/oxygenRetailSlice";
import useCustomAlert from "../components/Alert2";
import {setPreCustomerId} from "../redux/features/oxygen/oxygenRetailSlice";
import { updatePrecustomer } from "../redux/features/precustomers/PrecustomerSlice";
import {getFinancier} from "../redux/features/oxygen/oxygenRetailSlice";
import PageWrapper from "../layouts/Index";
import PageTitle from "../components/PageTitle";
import { oxygenFirstCustomerDetails } from "../services/oxygenRetailServices";
import { setShowModal } from "../redux/features/oxygen/customModalSlice";

const OxygenRetail = () => {
  const dispatch = useDispatch();
  const customAlert = useCustomAlert();
  const loggedInUser = useSelector((state) => state?.user?.user);
  const financier = useSelector((state) => state.oxygenRetail?.financiers);
  const oxygenFinancier = financier?.filter(item => Number(item.id) === 14 || Number(item.partnerId) === 408) || [];
  const allBanks = useSelector((state) => state.oxygenRetail?.allBanks) || [];
  // const employmentStatus = useSelector((state) => state.oxygenRetail?.employmentStatus) || [];
  const precustomer = useSelector((state) => state?.precustomer?.precustomerData) || [];
  const msisdn =  precustomer?.precustomer?.msisdn;

  useEffect(() => {
    dispatch(getAllBanks());
    dispatch(getEmploymentStatus());
    dispatch(getFinancier());
  }, [dispatch]);
  
  const employData = [
    { name: "SELF_EMPLOYED", id: "1" },
    { name: "UNEMPLOYED", id: "2" },
    { name: "EMPLOYED", id: "3" },
  ]

  localStorage.setItem("allAboard-financierid", JSON.stringify(oxygenFinancier[0]?.id));
  localStorage.setItem("financierName", JSON.stringify(oxygenFinancier[0]?.name));
  localStorage.setItem("allAboard-partnerid", JSON.stringify(oxygenFinancier[0]?.partnerId));

  const initialValues = {
    bank: "", 
    accountNumber: "",
    email: "",
    bvn: "",
    employmentStatus: "",
  };

  const handleSubmit = async (values) => {

    const formData = {
      msisdn: String(msisdn),
      email: values.email,
      bvn: String(values.bvn),
      bankCode: allBanks?.data?.find((bank) => bank.name === values.bank)?.sortCode, 
      bankName: values.bank,
      accountNumber: String(values.accountNumber),
      employmentStatus: values.employmentStatus,
      is_Self_Onboard: false,
      repId: Number(loggedInUser?.id),
      is_Modified: false,
      device_type_id: 0,
      preCustomerId: Number(precustomer?.precustomer?.precustomerId) || 0,
    };

    const res = await oxygenFirstCustomerDetails(formData);
    console.log("Oxygen First Customer Details Response:", res);

    const precustomerPayload = {
      precustomer: {
       ...precustomer?.precustomer,
        bvn: formData?.bvn,
        accountNumber: formData?.accountNumber,
        email: formData?.email,
        bankName: formData?.bankName,
        employmentStatus: formData?.employmentStatus,
      }
    };

    if(res?.status === true) {
      dispatch(setCustomermsisdn(res?.data));
      dispatch(setPreCustomerId(res?.preCustomerId));
      dispatch(updatePrecustomer({
        ...precustomerPayload,
        onboarding_status: "validate-otp-oxygen"
      }));
      customAlert.showToast("success", `Customer details submitted successfully, ${res?.message}`); 
      dispatch(setShowModal({
        status:true,
        type: 'oxyWaitingModal',
        data:{ msisdn:msisdn},
      }));
      
    }else if(res?.status === false && res?.responseCode === "Pending") {
      customAlert.showToast("error", `${res?.message}` || "Your request is pending manual review.");
      dispatch(updatePrecustomer(precustomerPayload));
      // manual review modal
      dispatch(setShowModal({
        status:true,
        title:"Manual Review",
        type:"manualReview",
        showCloseButton:false,
        data:{message:res?.message, msisdn:msisdn},
      }));
    }else {
      customAlert.showToast("error", `${res?.message}` || "Failed to submit customer details");
    }
  };

  return (
    <PageWrapper>
      <PageTitle title={`Prequalification Form`} />
      <div className="row">
        <div className="col-xl-6 col-lg-8 col-md-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Oxygen Customer</h4>
            </div>
            <div className="card-body">
              <Formik
                initialValues={initialValues}
                validationSchema={oxygenRetailSchema1}
                onSubmit={(values) => handleSubmit(values)}
              >
                {({
                  errors,
                  touched,
                  values,
                  handleBlur,
                  handleChange,
                  isSubmitting,
                  setFieldValue,
                  handleSubmit,
                }) =>{

                  return(
                  <Form>
                    <div className="row mb-2">
                      <div className="col-sm-12">
                        <CustomSelectField
                          label="Bank"
                          placeholder="Select Bank"
                          name="bank"
                          onChange={handleChange}
                          value={values.bank || ""} 
                          onBlur={handleBlur}
                          error={errors.bank}
                          touched={touched.bank}
                        >
                          {allBanks?.data?.map((item) => (
                            <option key={item.code} value={item.name}>
                              {item.name}
                            </option>
                          ))}
                        </CustomSelectField>
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-md-6 col-sm-12">
                        <CustomInputField
                          label="Account Number"
                          placeholder="Enter Account Number"
                          name="accountNumber"
                          value={values.accountNumber}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.accountNumber}
                          touched={touched.accountNumber}
                        />
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <CustomInputField
                          label="BVN"
                          placeholder="Enter Your BVN"
                          name="bvn"
                          type="number"
                          value={values.bvn}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.bvn}
                          touched={touched.bvn}
                        />
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-md-6 col-sm-12">
                        <CustomInputField
                          label="Email Address"
                          placeholder="Enter Your Email Address"
                          name="email"
                          type="email"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.email}
                          touched={touched.email}
                          readOnly={false}
                        />
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <CustomSelectField
                          label="Employment Status"
                          placeholder="Select Status"
                          name="employmentStatus"
                          onChange={handleChange}
                          value={values.employmentStatus}
                          onBlur={handleBlur}
                          error={errors.employmentStatus}
                          touched={touched.employmentStatus}
                        >
                          {/* {employmentStatus?.data?.map((item) => (
                            <option key={item.id} value={item.name}>
                              {item.name}
                            </option>
                          ))} */}
                          {employData?.map((item) => (
                            <option key={item.id} value={item.name}>
                              {item.name}
                            </option>
                          ))}
                        </CustomSelectField>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end align-items-center">
                      <button
                        type="submit"
                        className="btn btn-primary btn-lg"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Please wait..." : "Submit"}
                      </button>
                    </div>
                  </Form>
                )}
              }
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default OxygenRetail;


